import React from "react";
import { stateNames, } from "../../../../../../db/schema/orders.js";
import Button from "../../../../../shared/ui/inputs/classicButton.js";
import "./bucketManager.css";
import executeRequest from "../../../../../modules/request.js";
import { showError } from "../../scripts/showError.js";
import { setDTConfig } from "../index.js";
import { useGlobalUpdate } from "../../scripts/useGlobalUpdate.js";
import { UpdateBasketItemsCount } from "../navbar/navBar.js";
export default function BucketManager(props) {
    var _a, _b;
    const { emit, state } = useGlobalUpdate(UpdateBasketItemsCount);
    const hasDiscounts = ((_a = props.discounts) === null || _a === void 0 ? void 0 : _a.length) > 0;
    return (React.createElement("div", { className: "bucket-navbar-container" },
        React.createElement("div", null,
            "Kwota:",
            " ",
            hasDiscounts && (React.createElement("span", { className: hasDiscounts ? "price-with-discounts" : "" },
                props.priceWithoutDiscounts,
                " z\u0142")),
            React.createElement("b", null,
                " ",
                isNaN(props.totalPrice) ? 0 : props.totalPrice,
                " z\u0142"),
            React.createElement("br", null),
            props.paymentType === "cash" && props.state === "payed" ?
                React.createElement(React.Fragment, null, "P\u0142atno\u015B\u0107: Przy odbiorze")
                : React.createElement(React.Fragment, null,
                    "Status: ", (_b = stateNames.get(props.state)) !== null && _b !== void 0 ? _b : "nieznany")),
        React.createElement("div", { className: "action-buttons-menu" },
            (props.state === "waiting_for_payment" ||
                props.state === "complete") && (React.createElement(React.Fragment, null,
                React.createElement(Button, { version: "alternative", onClick: async () => {
                        const { status } = await executeRequest("/api/public/users/gallery/logout", "GET", {});
                        if (status !== 200)
                            return showError("Nie udało się wylogować. Przepraszamy");
                        props.onUpdate();
                    } }, "Wyloguj si\u0119"))),
            props.canSubmit &&
                (props.state == "while_ordering" ||
                    props.state == "waiting_for_payment") && (React.createElement(Button, { text: props.state == "waiting_for_payment" ?
                    "Opłać ponownie"
                    : "Złóż zamówienie", value: "add_order", onClick: props.onOrderSubmitted })),
            props.canSubmit && props.state == "payed" && (React.createElement(React.Fragment, null,
                React.createElement("span", { style: { color: "green" } }, props.paymentType === "cash" ?
                    React.createElement(React.Fragment, null, "Zam\u00F3wienie zosta\u0142o z\u0142o\u017Cone!")
                    : React.createElement(React.Fragment, null, "Zam\u00F3wienie zosta\u0142o op\u0142acone!")),
                React.createElement("div", { className: "summary-buttons-container" },
                    React.createElement(Button, { text: "Wyloguj si\u0119", version: "alternative", onClick: async () => {
                            await executeRequest("/api/public/users/gallery/logout", "GET", {});
                            emit((old) => old + 1);
                            sessionStorage.setItem("logged", "false");
                            setDTConfig((old) => ({ ...old, isLoggedIn: "false" }));
                            props.onUpdate();
                        } }),
                    props.orderKey && (React.createElement(Button, { text: "Zobacz Podsumowanie", value: "show-summary", onClick: () => window.open(`/order.html?orderId=${props.orderId}&key=${props.orderKey}`, "_blank") }))))))));
}
